export const fall_2026_3200_materials = {
    notes: [
        {
            name: "Symbolic Logic",
            link: "https://drive.google.com/file/d/1KpQqHOGKQkQy2EoCju4F0cC_Yh_atzCb/view?usp=sharing"
        },
        {
            name: "Proof Methods",
            link: "https://drive.google.com/file/d/1psifd6sbtQiYm1_gtKfyS0BY2tlMplbZ/view?usp=sharing"
        },
        {
            name: "Induction",
            link: "https://drive.google.com/file/d/13EdLJnRfc6jha-LsU7TciKSqqbZ0aH9J/view?usp=sharing"
        },
        {
            name: "Sets",
            link: "https://drive.google.com/file/d/1r8OoZC9dFucUEotO5gHk3Mx4_iiibC_Q/view?usp=sharing"
        },
        {
            name: "Functions and Relations",
            link: "https://drive.google.com/file/d/1KaSL9TP9lyBQQr1Iop_hzVuwmxBVTEwq/view?usp=sharing"
        }
    ],
    quizzes: [
        {
            name: "Homework 1",
            link: "https://drive.google.com/file/d/1-DtYz5qjmmQqn-X64wXZV8oQnrexqHEr/view?usp=sharing"
        },
        {
            name: "Homework 2",
            link: "https://drive.google.com/file/d/1FdZpaxCQMTPggmru59ezJ2yQwNUEcAN5/view?usp=sharing"
        },
        {
            name: "Homework 3",
            link: "https://drive.google.com/file/d/1kcOK2-aZa-kFbUuZyHcsz_aySvJ6T-4A/view?usp=sharing"
        },
        {
            name: "Homework 4",
            link: "https://drive.google.com/file/d/1N53q3XD5lyORY4Tw3V06ZIRSQWMP-EJ6/view?usp=sharing"
        },
        {
            name: "Homework 5",
            link: "https://drive.google.com/file/d/1HB-JklOj2_1wozUiIh9AZTg3olFwfOQd/view?usp=sharing"
        },
        {
            name: "Homework 6",
            link: "https://drive.google.com/file/d/1Pv-N4l4XHrZ0sEn428wbLvWyuZa6X31Q/view?usp=sharing"
        },
        {
            name: "Homework 7",
            link: "https://drive.google.com/file/d/1PGPDpDUI9JoCjJi_qfIAbQxX1ml1v688/view?usp=sharing"
        },
        {
            name: "Homework 8",
            link: "https://drive.google.com/file/d/1RhXGUCqened29tKe95CE8NycHGTRixm7/view?usp=sharing"
        },
        {
            name: "Homework 9",
            link: "https://drive.google.com/file/d/1rS-Ie1gxYWqw0ChAYFRPPYbC9v-JIbpV/view?usp=sharing"
        },
        {
            name: "Homework 10",
            link: "https://drive.google.com/file/d/1UuvCTWkFmS2YWizXWIKrEQ8bauntppje/view?usp=sharing"
        }
    ],
    exam: [
        {
            name: "Ideas for Exam 1",
            link: "https://drive.google.com/file/d/11MJXs8WXDwBqsnIR7Ul21srxEunSF7_m/view?usp=sharing"
        },
        {
            name: "Ideas for Exam 2",
            link: "https://drive.google.com/file/d/1ODdGr7QzXRgoC-CScXGbMZG4aCW8czKy/view?usp=sharing"
        }
    ],
};



// WEBPACK FOOTER //
// ./src/data/materials/fall_2026_3200_materials.js